import { Component } from '@angular/core';

@Component({
  selector: 'app-distributoronboard',
  templateUrl: './distributoronboard.component.html',
  styleUrls: ['./distributoronboard.component.css']
})
export class DistributoronboardComponent {

  ShowCard:any;
}
